


























































































import {
  SfBreadcrumbs,
  SfButton,
  SfHeading,
  SfInput,
  SfLink,
  SfLoader,
} from '~/components';

import {
  defineComponent, ref, useContext, onMounted, watch, computed
} from '@nuxtjs/composition-api';
import { useApi } from '~/composables/useApi';
import storeGetters from '~/modules/boutiques/getters/storeGetters';
import { useConfig, useMap } from '~/composables';
import BoutiqueItem from '../components/BoutiqueItem.vue';
import { boutiquesQuery } from '~/modules/boutiques/queries/getBoutiques';
import { useConfigStore } from "~/stores/config";

import { groupBy, toArray } from 'lodash-es';

import PerfectScrollbar from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'
import Vue from 'vue';
Vue.use(PerfectScrollbar)

export default defineComponent({
  name: 'Boutiques',
  head() {
    return {
      title: this.$i18n.t('Store Locator') as string
    };
  },
  components: {
    SfBreadcrumbs,
    SfButton,
    SfHeading,
    SfInput,
    SfLink,
    SfLoader,
    BoutiqueItem,
  },
  setup(_, { refs }) {
    const { i18n, localePath } = useContext();
    const { config } = useConfig();
    const { query } = useApi();
    const { createMap, setMarkerCluster, setPosition, getCurrentPosition, getDistance } = useMap();
    const { storeConfig } = useConfigStore();
    const websiteCode = computed(() => storeConfig.website_code);

    const breadcrumbs = ref([]);
    breadcrumbs.value = [
      {
        link: localePath('/'),
        text: i18n.t('Home') as string,
      },
      {
        link: '#',
        text: i18n.t('Store Locator') as string
      }
    ];

    const stores = ref([]);
    const sortedStores = ref([]);
    const groupedStores = ref();
    const loading = ref(false);
    const markers = ref([]);
    const selectedStore = ref('');

    onMounted(async () => {
      try {
        loading.value = true;
        const result = await query(boutiquesQuery);
        stores.value = result.data['boutiques'].items;
        groupedStores.value = groupBy(stores.value, 'address.country_name');
        groupedStores.value = toArray(groupedStores.value);

        const storeLanguage = config.value.locale.slice(0, 2);

        await createMap(refs.map, storeLanguage, {}, websiteCode.value === 'togas_at_website'
          ? [{ 'elementType': 'labels.icon', 'stylers': [{'visibility': 'on'},  {'color': '#333333'}, {'lightness': 40}]}]
          : []
        );

        markers.value = await setMarkerCluster(...[stores.value]);

        markers.value.forEach((marker) => {
          marker.addListener('click', () => {
            selectedStore.value = marker.title;
          });
        });

        const currentPosition = await getCurrentPosition();

        groupedStores.value = groupedStores.value
          .map(country => country
            .map(store => { return { ...store, dist: getDistance(storeGetters.getPosition(store), currentPosition) }}));

        sortedStores.value = stores.value
          .map(store => { return { ...store, dist: getDistance(storeGetters.getPosition(store), currentPosition) }})
          .sort((storeA, storeB) => { return storeA.dist - storeB.dist; });

        watch(loading, () => {
          selectStore(storeGetters.getPosition(sortedStores.value[0]));
          selectedStore.value = storeGetters.getName(sortedStores.value[0]);
        });
      } catch {
        sortedStores.value = stores.value;
        watch(loading, () => {
          selectStore(storeGetters.getPosition(sortedStores.value[0]));
          selectedStore.value = storeGetters.getName(sortedStores.value[0]);
        });
      } finally {
        loading.value = false;
      }
    });

    watch(selectedStore, () => {
      refs[selectedStore.value][0]?.$el.scrollIntoView();
    });

    const selectStore = (position) => {
      setPosition(position);
      window.scrollTo({ top: 0 });
    };

    const isStoresFiltered = ref(false);
    const filteredStores = ref([]);
    const filteredStoresCount = computed(() => filteredStores.value.reduce((acc, item) => acc + item.length, 0));

    const searchTerm = ref('');
    const searchStore = (searchTerm) => {
      isStoresFiltered.value = true;
      filteredStores.value = [];

      filteredStores.value = groupedStores.value.filter(country => {
        const filteredCountry = country.filter(store => (store.address.postcode + store.address.city).toLowerCase().includes(searchTerm.toLowerCase()));
        return !!filteredCountry.length;
      })
    };

    const clearSearch = () => {
      searchTerm.value = '';
      isStoresFiltered.value = false;
    };

    const handleInput = () => {
      if (!searchTerm.value) {
        clearSearch();
      }
    };

    return {
      breadcrumbs,
      stores,
      loading,
      selectStore,
      searchTerm,
      searchStore,
      getDistance,
      ...storeGetters,
      filteredStores,
      isStoresFiltered,
      filteredStoresCount,
      clearSearch,
      handleInput,
      markers,
      selectedStore,
      groupedStores
    };
  }
});
